import type { ApiFilestackImageData } from '#/api/types/ApiFilestackImageData';
import { Button } from '#/components/Button/Button';
import { Body } from '#/components/Text/Body';
import { H2 } from '#/components/Text/H2';
import { trackAnchorClicked } from '#/utils/analytics/track/trackAnchorClicked';

import {
  CmsTwoTilesBlockTile_Box_1,
  CmsTwoTilesBlockTile_Box_2,
} from './CmsTwoTilesBlockTile.styled';

type Props = {
  buttonText: string | null;
  buttonUrl: string | null;
  dataQaPrefix: string;
  headline: string;
  text: string;
  image?: ApiFilestackImageData;
  blockIndex: number;
  pageUpdated: string;
  second?: boolean;
};

export function CmsTwoTilesBlockTile({
  buttonText,
  buttonUrl,
  dataQaPrefix,
  headline,
  text,
  blockIndex,
  pageUpdated,
  second,
}: Props) {
  return (
    <CmsTwoTilesBlockTile_Box_2
      data-second={second ? true : undefined}
      data-qa-prefix={dataQaPrefix}
    >
      <H2 style={{ margin: '0' }}>{headline}</H2>
      <div style={{ marginTop: '20px', width: '100%', flex: '1 1 auto' }}>
        <Body
          analyticsData={{
            eventName: 'CMS Block',
            eventProperties: {
              block_position: blockIndex,
              block_type: 'Two Tiles',
            },
          }}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </div>
      {buttonText && buttonUrl && (
        <CmsTwoTilesBlockTile_Box_1>
          <Button
            variant="primary"
            type="link"
            href={buttonUrl}
            onClick={(event) =>
              trackAnchorClicked(event, 'CMS Block', {
                block_position: blockIndex,
                block_type: 'Two Tiles',
                cta_type: 'Button',
                button_text: buttonText,
                page_updated: pageUpdated,
              })
            }
          >
            {buttonText}
          </Button>
        </CmsTwoTilesBlockTile_Box_1>
      )}
    </CmsTwoTilesBlockTile_Box_2>
  );
}
